import { Fragment } from "react"
import FormItem from "features/onboarding/SetGoal/Steps/SetTargetWeight/FormItem"
import { StyledWeeklyOption } from "./styled"
import { FlexBox } from "components/Common/FlexBox"
import { Title24 } from "components/Typo"
import { TitleBox } from "features/onboarding/PersonalInfo/styled"
import { IWeeklyGoal } from "features/onboarding/types"
import { IBodyDisplayUnits } from "features/profile/profileTypes"
import {
  getDefaultBodyWeight,
  getTargetWeightRange,
} from "utils/weightConverter"
import OneDecimalWheelPicker from "components/inputs/OneDecimalWheelPicker"

export interface IWeeklyOption {
  label: string
  value: IWeeklyGoal
}

interface ISetTargetWeightProps {
  weightChangePerWeek: IWeeklyGoal
  onWeightChangePerWeekChange: (value: IWeeklyGoal) => void
  targetWeight: number
  onTargetWeightChange: (value: number) => void
  typeName: "WEIGHT_LOSS" | "BUILDING"
  bodyDisplayUnits: IBodyDisplayUnits
  currentWeightInGrams: number
  disabled?: boolean
}

const SetTargetWeight = (props: ISetTargetWeightProps) => {
  const {
    weightChangePerWeek,
    onWeightChangePerWeekChange,
    targetWeight,
    onTargetWeightChange,
    typeName,
    bodyDisplayUnits,
    currentWeightInGrams,
    disabled,
  } = props

  const { min, max } = getTargetWeightRange(bodyDisplayUnits, currentWeightInGrams, typeName)
  const minInteger = Math.floor(min)
  const minDecimalAtMinInteger = Math.round((min - minInteger) * 10)
  const maxInteger = Math.floor(max)
  const maxDecimalAtMaxInteger = Math.round((max - maxInteger) * 10)

  const labelPrefix = typeName === "BUILDING" ? "Gain" : "Lose"
  const weightUnit = bodyDisplayUnits === "IMPERIAL" ? "lb" : "kg"

  const options: IWeeklyOption[] =
    bodyDisplayUnits === "METRIC"
      ? [
          {
            label: " 0.25 kg per week",
            value: 0.25,
          },
          {
            label: " 0.5 kg per week (Recommended)",
            value: 0.5,
          },
          {
            label: " 0.75 kg per week",
            value: 0.75,
          },
          {
            label: " 1 kg per week",
            value: 1,
          },
        ]
      : [
          {
            label: " 0.5 lb per week",
            value: 0.5,
          },
          {
            label: " 1 lb per week (Recommended)",
            value: 1,
          },
          {
            label: " 1.5 lb per week",
            value: 1.5,
          },
          {
            label: " 2 lb per week",
            value: 2,
          },
        ]
  return (
    <Fragment>
      <TitleBox style={{ paddingLeft: 8 }}>
        <Title24>Weekly Goal </Title24>
      </TitleBox>

      <div style={{ marginTop: 12 }}>
        <FormItem
          labelStyle={{ paddingLeft: 8 }}
          label="What is your goal weight?"
        >
          <OneDecimalWheelPicker
            label="Weight"
            placeholder="Enter your goal weight"
            onChange={onTargetWeightChange}
            detailTrailing={weightUnit}
            disabled={disabled}
            value={targetWeight}
            minInteger={minInteger}
            maxInteger={maxInteger}
            minDecimalAtMinInteger={minDecimalAtMinInteger}
            maxDecimalAtMaxInteger={maxDecimalAtMaxInteger}
            defaultInteger={getDefaultBodyWeight(bodyDisplayUnits)}
          />
        </FormItem>
      </div>

      <div style={{ marginTop: 14, marginBottom: 14 }}>
        <FormItem
          labelStyle={{ paddingLeft: 8 }}
          label="What is your weekly goal?"
        >
          <FlexBox $gap={10} $direction="column" style={{ padding: "0 1px" }}>
            {options.map((option) => (
              <StyledWeeklyOption
                key={option.value}
                onClick={() => {
                  if (!disabled) {
                    onWeightChangePerWeekChange(option.value)
                  }
                }}
                $active={weightChangePerWeek === option.value}
              >
                {labelPrefix}
                {option.label}
              </StyledWeeklyOption>
            ))}
          </FlexBox>
        </FormItem>
      </div>

    </Fragment>
  )
}

export default SetTargetWeight
